import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect, useRef } from "react"
import { useCreateZS } from "../../../../../components/WMS/SalesOrders/useCreateZS"
import DocumentDraftBootstrapPage from "../../../../../components/WMS/shared/DocumentDraftBootstrapPage"

type Search = {
  warehouseId?: string
}

type RawSearch = {
  warehouseId?: unknown
}

export const Route = createFileRoute("/_layout/WMS/documents/sales-orders/new")(
  {
    component: CreateSalesOrderDraftPage,
    validateSearch: (search: RawSearch): Search => ({
      warehouseId:
        typeof search.warehouseId === "string" ? search.warehouseId : undefined,
    }),
  },
)

function CreateSalesOrderDraftPage() {
  const navigate = useNavigate()
  const { warehouseId } = Route.useSearch()
  const { createZS, isCreating, isLoadingWarehouses, canCreate } = useCreateZS()
  const autoCreatedRef = useRef(false)

  const handleCancel = () =>
    navigate({
      to: warehouseId
        ? "/WMS/warehouses/$warehouse"
        : "/WMS/documents/document-list",
      ...(warehouseId
        ? { params: { warehouse: warehouseId } }
        : { search: { page: 1, page_size: 50 } }),
    } as any)

  useEffect(() => {
    if (autoCreatedRef.current || isLoadingWarehouses) return
    if (!canCreate) return
    autoCreatedRef.current = true
    void createZS({ preferredWarehouseId: warehouseId, replace: true })
  }, [canCreate, createZS, isLoadingWarehouses, warehouseId])

  return (
    <DocumentDraftBootstrapPage
      title="Utwórz dokument ZS"
      onCancel={handleCancel}
      isBusy={isCreating || isLoadingWarehouses}
      canCreate={canCreate}
      busyLabel="Tworzenie szkicu ZS..."
      idleLabel="Przygotowywanie edycji dokumentu ZS..."
    />
  )
}
